import { FetchReportDataFailureAction, FetchReportDataRequestAction, FetchReportDataSuccessAction, ReportActionTypes, ReportFilters } from '../../types/types';

export const fetchReportDataRequest = (filters: ReportFilters): FetchReportDataRequestAction => ({
  type: ReportActionTypes.FETCH_REPORT_DATA_REQUEST,
  payload: { filters },
});

export const fetchReportDataSuccess = (answers: any[], statuses: any[]): FetchReportDataSuccessAction => ({
  type: ReportActionTypes.FETCH_REPORT_DATA_SUCCESS,
  payload: { answers, statuses },
});

export const fetchReportDataFailure = (error: string): FetchReportDataFailureAction => ({
  type: ReportActionTypes.FETCH_REPORT_DATA_FAILURE,
  payload: { error },
});
